import { Injectable } from '@angular/core';
import { config } from 'src/app/shared/config';

@Injectable({
    providedIn: 'root'
})
export class LoggerService {

    constructor() { }

    logObj(msg: any) {
      if (config.environment == 'local') {
            console.log(msg);
      }
    }
    logMsg(msg: string) {
            console.log(msg);
    }
    logError(msg: string) {
            console.error(msg);
    }
    log(msg: any) {
    if (config.environment == 'local') {
          console.log(msg);
    }else{

    }
  }

}
